var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudEmoji({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.9488C6.10571 2.9488 2.94874 6.10577 2.94874 10.0001C2.94874 13.8944 6.10571 17.0514 10 17.0514C13.8943 17.0514 17.0513 13.8944 17.0513 10.0001C17.0513 6.10577 13.8943 2.9488 10 2.9488ZM1.66669 10.0001C1.66669 5.39771 5.39765 1.66675 10 1.66675C14.6024 1.66675 18.3334 5.39771 18.3334 10.0001C18.3334 14.6025 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6025 1.66669 10.0001ZM6.79489 8.29068C6.79489 7.93665 7.08189 7.64965 7.43592 7.64965H7.44447C7.79849 7.64965 8.08549 7.93665 8.08549 8.29068C8.08549 8.64471 7.79849 8.93171 7.44447 8.93171H7.43592C7.08189 8.93171 6.79489 8.64471 6.79489 8.29068ZM11.9231 8.29068C11.9231 7.93665 12.2101 7.64965 12.5641 7.64965H12.5727C12.9267 7.64965 13.2137 7.93665 13.2137 8.29068C13.2137 8.64471 12.9267 8.93171 12.5727 8.93171H12.5641C12.2101 8.93171 11.9231 8.64471 11.9231 8.29068ZM7.12929 11.9643C7.37962 11.7139 7.7855 11.7139 8.03584 11.9643C9.12063 13.0491 10.8794 13.0491 11.9642 11.9643C12.2145 11.7139 12.6204 11.7139 12.8708 11.9643C13.1211 12.2146 13.1211 12.6205 12.8708 12.8708C11.2853 14.4563 8.71475 14.4563 7.12929 12.8708C6.87895 12.6205 6.87895 12.2146 7.12929 11.9643Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudEmoji);
export default __webpack_public_path__ + "static/media/saud-emoji.968562e2a9f9328f0953cc3ff52f2eab.svg";
export { ForwardRef as ReactComponent };